<mat-toolbar xmlns="http://www.w3.org/1999/html">

    <div fxLayout="column" fxLayoutAlign="start center" fxFlex>

        <div class="footer-info-block" [ngStyle]="{'color': textColor}">
            <p>
                <span [ph]="'footer.copyrightPrefix'">Copyright © </span>
                <span [ph]="'footer.copyrightYear'">{{currentYear}} </span>
                <ng-container *ngTemplateOutlet="linkTemplate; context:{link: footerData?.copyrightCompanyLink || defaultCompanyLink, class: 'font-weight-500'}"></ng-container>&nbsp;
                <span [ph]="'footer.copyrightSuffix'"> -&nbsp;All&nbsp;Rights&nbsp;Reserved. </span>
                <ng-container *ngFor="let link of footerData?.links">
                    <ng-container *ngTemplateOutlet="linkTemplate; context:{link: link, class: 'flink'}"></ng-container>
                </ng-container>
                <ng-container *ngTemplateOutlet="linkTemplate; context:{link: footerData?.supportLink, class: 'flink'}"></ng-container>
            </p>
        </div>
    </div>

</mat-toolbar>

<ng-template #linkTemplate let-link="link" let-class="class">
    <ng-container [ngSwitch]="link?.url">
        <a *ngSwitchCase="'#privacy-policy'" (click)="showPrivacyPolicy()" target="{{link?.target}}" class="{{class}}">{{link?.title}}</a>
        <a *ngSwitchCase="'#terms-of-service'" (click)="showTermsOfUse()" target="{{link?.target}}" class="{{class}}">{{link?.title}}</a>
        <a *ngSwitchDefault href="{{link?.url}}" target="{{link?.target}}" class="{{class}}">{{link?.title}}</a>
    </ng-container>
</ng-template>
